import { render, staticRenderFns } from "./payFeeOrderResult.vue?vue&type=template&id=0cf4b17e&scoped=true"
import script from "./payFeeOrderResult.vue?vue&type=script&lang=js"
export * from "./payFeeOrderResult.vue?vue&type=script&lang=js"
import style0 from "./payFeeOrderResult.vue?vue&type=style&index=0&id=0cf4b17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4b17e",
  null
  
)

export default component.exports